var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section_wrap"},[_c('h6',{staticClass:"--blue70"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t( 'report.components.expert_opinion' ))+"\n    ")]),_c('div',{staticClass:"section_body"},[_c('KvTable',{staticClass:"table",attrs:{"items":_vm.expertOpinionSectionItems}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }